module.exports = __webpack_public_path__ + "static/media/GBR Network DTN Agribusiness - GBR Network - 01-04-2025 C.d32ba030.gif";